import s from './style.css';
import cn from 'classnames';
import TextWrapper from 'components/TextWrapper';

const calcRadius = (value, max, size) => Math.sqrt(value / max) * size;

const ScaledPullOut = ({
	data,
	copy,
	onRight,
	inView,
	highlight,
	highlightColors
}) => {
	const max = 65;
	const normalizedData = data.map(datum => ({
		...datum,
		radius: calcRadius(datum.percentage, max, 100)
	}));

	return (
		<TextWrapper
			copy={copy}
			highlight={highlight}
			highlightColors={highlightColors}
			onRight={!!onRight}
		>
			<div
				className={cn({
					[s.spaced]: data.length > 2,
					[s.sideRight]: onRight
				})}
			>
				<div className={s.container}>
					<div className={cn(s.chartWrapper, { [s.hidden]: !inView })}>
						{normalizedData.map(
							({ fact, percentage, color, radius, factBelow }, i) => (
								<div className={s.responsive}>
									<div className={s.circleWrap}>
										<div
											className={s.circle}
											style={{
												width: `${radius}%`,
												height: `${radius}%`,
												background: color
											}}
										>
											<div
												className={cn(s.fact, { [s.factBelow]: factBelow })}
												style={{
													width: `${radius}%`
												}}
											>
												{percentage}% {fact}
											</div>
										</div>
									</div>
								</div>
							)
						)}
					</div>
				</div>
			</div>
		</TextWrapper>
	);
};

export default ScaledPullOut;



// WEBPACK FOOTER //
// ./components/ScaledPullOut/index.js